import { t } from "@impero-com/common/utils/i18n";
import { notifyRequestError } from "@impero-com/common/utils/query_client";
import { emitNotification } from "@impero-com/ui";
import { useQueryClient } from "@tanstack/react-query";

import {
    getGetEntitiesQueryKey,
    useDeleteEntitiesEntityId,
} from "api/generated/entities/entities";

export function useDeleteEntityMutation() {
    const queryClient = useQueryClient();
    return useDeleteEntitiesEntityId({
        mutation: {
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: getGetEntitiesQueryKey(),
                });
            },
            onError: (error) => {
                if (error?.response?.status === 409) {
                    const errorText =
                        error.response.data.code === "ReferencedInDatasheet"
                            ? t("EntityView_DeleteAction_DataSheet_Conflict")
                            : t("EntityView_DeleteAction_Conflict");
                    emitNotification("error", errorText);
                    return;
                }
                notifyRequestError(error);
            },
        },
    });
}
